module.exports = __webpack_public_path__ + "img/level2addon_idle_shadow.10c7b7d1.png";